/**
 * Component to sync Clerk token to sessionStorage for RTK Query
 */

import { useEffect } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { setCurrentToken } from '../services/api';

export function TokenSync() {
  const { getToken, isSignedIn, isLoaded } = useAuth();

  useEffect(() => {
    // Don't sync until Clerk is fully loaded
    if (!isLoaded) {
      console.log('[TokenSync] Waiting for Clerk to load...');
      return;
    }

    const syncToken = async () => {
      if (isSignedIn) {
        try {
          const token = await getToken();
          setCurrentToken(token);
          console.log('[TokenSync] Token synced, length:', token?.length || 0);
        } catch (error) {
          console.error('[TokenSync] Failed to get token:', error);
          setCurrentToken(null);
        }
      } else {
        setCurrentToken(null);
        console.log('[TokenSync] Token cleared (user signed out)');
      }
    };

    // Sync immediately when Clerk loads
    syncToken();

    // Refresh token every 30 seconds to keep it fresh
    const interval = setInterval(syncToken, 30000);

    return () => clearInterval(interval);
  }, [isLoaded, isSignedIn, getToken]);

  return null; // This component doesn't render anything
}
